/**
 * `ОБН.3` (`АРХ-Н25`): допустимые пары «тип образа — изделие» на фронте.
 *
 * Таблица повторяет серверную (`back_balance/service/firmware-product.js`) —
 * так форма знает, что предлагать, не спрашивая сервер на каждый кадр. Решение
 * всё равно за сервером: он проверяет пару ещё раз при загрузке и запуске.
 * Совпадение перечней проверяется тестом (`obn3-firmware-product.test.tsx`).
 */
export const PRODUCTS_BY_TYPE: Record<string, string[]> = {
  ESP: ["mdbn", "smb", "mmb"],
  STM: ["mdbn", "smb", "mmb"],
  AC_control: ["ac_m"],
};

export const PRODUCT_TITLES: Record<string, string> = {
  mdbn: "МДБН",
  smb: "СМБ",
  mmb: "ММБ",
  ac_m: "AC-M",
};

export const DEVICE_TYPES = ["mdbn", "smb", "mmb"];

export function productsForType(type: string): string[] {
  return PRODUCTS_BY_TYPE[type] || [];
}

export function productTitle(product: string | null | undefined): string {
  if (!product) return "не привязан";
  return PRODUCT_TITLES[product] || product;
}

/**
 * Изделие образа, подходящее модулю. `EDGE`: у `AC_control` образ один (`ac_m`)
 * и годится МДБН и СМБ; у ММБ станций нет, поэтому образа нет вовсе.
 */
export function imageProductForDevice(
  type: string,
  deviceType: string | null | undefined,
): string | null {
  const device = String(deviceType || "").toLowerCase();

  if (type === "AC_control") {
    return device === "mdbn" || device === "smb" ? "ac_m" : null;
  }

  return DEVICE_TYPES.includes(device) ? device : null;
}

/** Подходит ли образ этому типу блока у этого изделия. */
export function isFirmwareSuitable(
  firmware: { product?: string | null },
  type: string,
  deviceType: string | null | undefined,
): boolean {
  const wanted = imageProductForDevice(type, deviceType);

  return wanted !== null && firmware.product === wanted;
}
